import React from 'react';
import MainLayout from '../layouts/MainLayout';

function Contact() {
  return (
    <MainLayout>
      <section id="contact" className="contact section light-background py-5">

        {/* Section Title */}
        <div className="container section-title text-center mb-5" data-aos="fade-up">
          <h1 className="display-2 fw-bolder mb-4  text-uppercase text-heritage-maroon">
            Contact
          </h1>
          <div><span>Need Help?</span> <span className="description-title text-heritage-maroon">Contact Us</span></div>
        </div>{/* End Section Title */}

        <div className="container" data-aos="fade-up" data-aos-delay="100">

          <div className="row gy-4">
            <div className="col-lg-6 ">
              <div className="row gy-4">

                <div className="col-lg-12">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center bg-white p-4 rounded-4 shadow-sm border-gold h-100" data-aos="fade-up"
                    data-aos-delay="200">
                    <i className="bi bi-geo-alt fs-2 mb-2 text-heritage-maroon"></i>
                    <h3 className="fw-bold fs-5">Address</h3>
                    <p className=" text-muted mb-0"><b>1. Mahawar Dhramshala</b>, Dholia Kuan, Jeewli Bazar, Rewari - 123401, Haryana, India<br />
                      <br /><b>2. Mahawar Palace</b>, Near Pushpanjli Hospital, Colonel Ram Singh Chowk, Plot No. 1, Sector-4, Byepass Road, Rewari-123401, Haryana, India</p>
                  </div>
                </div>{/* End Info Item */}

                <div className="col-md-6 d-flex">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 bg-white p-4 rounded-4 shadow-sm border-gold"
                    data-aos="fade-up" data-aos-delay="300">

                    <i className="bi bi-telephone fs-2 mb-2 text-heritage-maroon"></i>
                    <h3 className="fw-bold fs-5">Contact</h3>

                    <p className="mb-2 text-muted"><b>📧</b> mvsrwr@gmail.com</p>
                    <p className="mb-0 text-muted">👥 9992699979</p>

                  </div>
                </div>{/* End Info Item */}

                <div className="col-md-6 d-flex">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center text-center h-100 w-100 bg-white p-4 rounded-4 shadow-sm border-gold"
                    data-aos="fade-up" data-aos-delay="400">

                    <i className="bi bi-card-checklist fs-2 mb-2 text-heritage-maroon"></i>
                    <h3 className="fw-bold fs-5">Reg No.</h3>
                    <p className="mb-0 text-muted">HR/RWR/2014/00309</p>

                  </div>
                </div>{/* End Info Item */}

              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="500">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3516.8594736668997!2d76.62624307548442!3d28.181188875914195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d50174fa818a3%3A0x855a0d1062872d95!2sMahawar%20Palace!5e0!3m2!1sen!2sin!4v1777085046120!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: '10px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </div>

          </div>

        </div>

      </section>{/* /Contact Section */}
    </MainLayout>
  );
}

export default Contact;